import { APIPost, APIUrl, AdminType } from "api/protocols";
import { IOrderTransaction } from "redux/reducers/models/order";

export type TRefundType = "item_return" | "payment_adjustment";

export interface IOrderRefundBalance {
  active_sales: number;
  active_payments: number;
  overpayment_amount: number;
  underpayment_amount: number;
  refundable_tip: number;
  refundable_service_fee: number;
}

export interface IRefundAllocation {
  tip: number;
  service_fee: number;
  overpayment: number;
}

interface IPostRefund {
  order_id?: number;
  refund_type?: TRefundType;
  refund_line_items?: { line_item_id: number; refund_quantity: number; refund_amount: number }[];
  refund_transactions?: any[];
  refund_tip_amount?: number;
  refund_service_fee_amount?: number;
  refund_overpayment_amount?: number;
  note?: string;
}

interface IPostCalculateRefund {
  order_id?: number;
  refund_type?: TRefundType;
  refund_line_items?: { line_item_id: number; refund_quantity: number; refund_amount: number }[];
  refund_transactions?: IOrderTransaction[];
  refund_tip_amount?: number;
  refund_service_fee_amount?: number;
}

export async function PostRefund(params: IPostRefund, useGlobalLoader: boolean) {
  return await APIPost(APIUrl(AdminType.FacilityAdmin, "/order/refund"), params, useGlobalLoader);
}

export async function PostCalculateRefund(params: IPostCalculateRefund, useGlobalLoader: boolean) {
  return await APIPost(APIUrl(AdminType.FacilityAdmin, "/order/refund/calculate"), params, useGlobalLoader);
}
